document.addEventListener('DOMContentLoaded', () => {
  const accordionBlocks = document.querySelectorAll('.accordion-block');

  if (!accordionBlocks.length) return;

  accordionBlocks.forEach(block => {
    const accordions = block.querySelectorAll('.accordion-item');

    accordions.forEach(item => {
      const button = item.querySelector('.accordion-item__header');
      const content = item.querySelector('.accordion-item__content');

      button.addEventListener('click', () => {
        const isExpanded = button.getAttribute('aria-expanded') === 'true';

        // Close all within this block
        accordions.forEach(acc => {
          const accButton = acc.querySelector('.accordion-item__header');
          accButton.setAttribute('aria-expanded', 'false');
          acc.classList.remove('active');
        });

        // Toggle clicked one
        if (!isExpanded) {
          button.setAttribute('aria-expanded', 'true');
          item.classList.add('active');
        }
      });

      // Keyboard accessibility
      button.addEventListener('keydown', e => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          button.click();
        }
      });
    });
  });
});
